<template>
  <div class="feature">
    <div class="title">
       {{ $t("home.feature_in_recognise_by") }}
    </div>
    <div class="content">
      <div class="icons-section">
        <img class="icons" src="./../../assets/imgs/pc/featuredIn/smartCitiesTechColor.png" alt="">
        <img class="icons" src="./../../assets/imgs/pc/featuredIn/startupDailyColor.png" alt="">
        <img class="icons" src="./../../assets/imgs/pc/featuredIn/marketingInAsiaStartup.png" alt="">
      </div>
    </div>
  </div>
</template>


<script>
export default {
  
}
</script>


<style lang="scss" scoped>

.feature{
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
}

.title{
  color: #314455;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  line-height: 18px; 
}

.icons{
  width: 250px;
  height: auto;
}
.icons-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 64px;
}

@media screen and ( max-width: 920px ) and (min-width: 769px) {
  .icons{
    width: 200px;
    height: auto;
  }
}
@media screen and ( max-width: 768px ){
  .icons-section {
    gap: 15px;
  }
  .icons{
    width: 100px;
    height: auto;
  }
}
</style>
